import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Super Dispatch integration data.
 *
 * @remarks
 * System-managed object storing Super Dispatch reference data for status
 * synchronization operations.
 */
export const schema = z
  .object({
    vehicle_id: z.number().describe('Super Dispatch vehicle ID').optional(),
    reference_num: z.number().describe('Super Dispatch reference number for status sync').optional(),
  })
  .strict()
  .optional();

export type SuperDispatch = z.infer<typeof schema>;

export const definition = define({
  key: 'superDispatch',
  schema,
  label: 'Super Dispatch',
  description:
    'Super Dispatch integration reference data for status sync. Set by super-dispatch-integration, not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
